import _ from "lodash";
import { fetch } from "src/services/apollo-fetch";
import { Query } from "./_api";

async function fetchCustomers(data) {
    const response = await fetch.query({
        query: Query.customerSearch,
        variables: data,
    });
    console.log(response.data.customers);
    return response.data.customers;
}

export default {
    searchCustomers: _.debounce(
        async (context, search) => {
            return await fetchCustomers({ limit: 50, search });
        },
        500, // 500ms
        { leading: true, trailing: true },
    ),
};
